import AccordionList from './accordionList';
import AccordionListItem from './accordionListItem';

const Accordion = {
  List: AccordionList,
  Item: AccordionListItem,
};

export default Accordion;
